import React from "react";
import { 
    Level, LevelItem, Divider
} from '@patternfly/react-core';
import Moment from 'moment';
import { formatBytes } from 'shared/utils/formatBytes'

const SummaryDiskInfo = ({ 
  diskUsageBytes,
  diskSize,
  diskName,
  createdAt,
  loading
}) => {

  return (
    <>
      {/* Nazwa dysku */}
      <Level>
          <LevelItem><small><b>Nazwa dysku:</b></small></LevelItem>
          <LevelItem>
              {loading ? "" : diskName}
          </LevelItem>
          <Divider/>
      </Level>
      {/* Rozmiar dysku */}
      <Level>
          <LevelItem><small><b>Rozmiar:</b></small></LevelItem>
          <LevelItem>
              {loading ? "" : formatBytes(diskSize)}
          </LevelItem>
          <Divider/>
      </Level>
      {/* Rozmiar dysku */}
      <Level>
          <LevelItem><small><b>Zajęte:</b></small></LevelItem>
          <LevelItem>
              {loading ? "" : formatBytes(diskUsageBytes)}
          </LevelItem>
          <Divider/>
      </Level>
      {/* Utworzono */}
      <Level>
          <LevelItem><small><b>Utworzono:</b></small></LevelItem>
          <LevelItem>
              {loading ? "" : Moment(createdAt).format('DD.MM.YYYY H:mm a')}
          </LevelItem>
          <Divider/>
      </Level>
    </>
  );
};

export default SummaryDiskInfo;